import React, { useState, useContext } from "react";
import { sendFilterPurchasesData } from "../../../apis/apis.buys/apisPurchase";
import { getCurrentDate } from "../../../configs/helpers";
import { toast } from "react-toastify";
import { ContextAuth } from "../../../contexts/ContextAuth";

export function PurchaseFilter({ setOrders }) {
    const { auth } = useContext(ContextAuth);
    const sendFilterPurchases = async (data) => {
        try {
            const response = await sendFilterPurchasesData(data);
            return response;
        } catch (error) {
            throw error;
        }
    };

    //state to hold responses from input
    const [questionState, setQuestionState] = useState({
        options: [{ radioName: "actions", selected: "" }],
        suggest: "",
        startDate: getCurrentDate("-"),
        endDate: getCurrentDate("-"),
        subsidiaryID: auth.data.subsidiary.subsidiary_id,
    });

    //radio buttons onchange
    const handleChange = (e) => {
        const { options } = questionState;
        const { name, value } = e.target;
        //console.log(name, value);

        const nextState = options.map((opt) => {
            if (opt.radioName !== name) {
                return { ...opt };
            } else {
                return { ...opt, selected: value };
            }
        });

        setQuestionState({ ...questionState, options: nextState });
    };

    function handleChangeSuggest(e) {
        setQuestionState({ ...questionState, suggest: e.target.value });
    }

    function handleChangeDate(e) {
        setQuestionState({ ...questionState, [e.target.name]: e.target.value });
    }

    const handleKeyDownSupplier = async (e) => {
        if (e.keyCode === 13) {
            searchSuggestions();
        }
    };

    const handleQuery = (e) => {
        searchSuggestions();
    };

    function searchSuggestions() {
        sendFilterPurchases(questionState).then((res) => {
            let results = res.length;
            toast.info(
                results > 1
                    ? "Se encontraron " + results.toString() + " resultados."
                    : "Se encontró " + results.toString() + " resultado(s).",
            );
            setOrders(res);
        });
    }

    const inputClass =
        "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
    const labelClass =
        "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-4 mb-6">
            <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-end">
                <div className="flex flex-col gap-2">
                    <span className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                        Buscar x
                    </span>
                    <div className="flex flex-wrap gap-3 items-center">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="radio"
                                name="actions"
                                value="id"
                                onChange={handleChange}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700"
                            />
                            <span className="text-sm text-gray-700 dark:text-gray-300">
                                ID
                            </span>
                        </label>
                        <span className="text-gray-400">/</span>
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="radio"
                                name="actions"
                                value="supplierName"
                                onChange={handleChange}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700"
                            />
                            <span className="text-sm text-gray-700 dark:text-gray-300">
                                Proveedor
                            </span>
                        </label>
                        <span className="text-gray-400">/</span>
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="radio"
                                name="actions"
                                value="supplierDocumentNumber"
                                onChange={handleChange}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700"
                            />
                            <span className="text-sm text-gray-700 dark:text-gray-300">
                                Ruc
                            </span>
                        </label>
                    </div>
                </div>

                <div className="flex-1 w-full">
                    <input
                        type="text"
                        className={inputClass}
                        name="suggest"
                        placeholder="Ingrese Texto (3 caracteres como minimo)"
                        onChange={handleChangeSuggest}
                        onKeyDown={handleKeyDownSupplier}
                        maxLength={50}
                        autoComplete="off"
                    />
                </div>

                <span className="text-gray-500 dark:text-gray-400 self-center">
                    y/o
                </span>

                <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                    <input
                        type="date"
                        name="startDate"
                        className={inputClass}
                        value={questionState.startDate}
                        onChange={handleChangeDate}
                    />
                    <input
                        type="date"
                        name="endDate"
                        className={inputClass}
                        value={questionState.endDate}
                        onChange={handleChangeDate}
                    />
                </div>

                <button
                    className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                    onClick={handleQuery}
                    id="btn-filter"
                >
                    <i className="fas fa-search"></i>
                    Buscar
                </button>
            </div>
        </div>
    );
}
